export const APP_NAME = 'recaudo-movil';
